



interface LanguageEntry {
    Header: string;
    Content: string;
}

export class GlobalOperations {
      static BaseUrl: string = "https://ccapi.albinasoft.com/";
    //static BaseUrl: string = "http://localhost:60295/";
    static SignalRBaseUrl:string = "https://ccapisignalr.albinasoft.com";//http://localhost:5147
    static ConnectionHubId: string = "";
    static SignalRConnection: signalR.HubConnection | null = null;
    static ActiveSessionId: number = 0;
    static ClientId: number = 0;
    static ServiceId:number = 0;

    static UserName: string = "";
    static UserToken: string = "";

    constructor() {

    }

    static IsNullOrEmpty(value: string | null | undefined): boolean {
        return value === null || value === undefined || value.trim() === "";
    }



}

